/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlineFlight, MdDirectionsBus } from 'react-icons/md';
import {
  LuGlobe2,
  LuShieldCheck,
  LuCable,
  LuCog,
  LuMonitorSmartphone,
  LuHotel,
  LuCircleDollarSign,
  LuBedDouble,
} from 'react-icons/lu';

import Login from './Login';
import './LoginPagefly24hrs.scss';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppHidden from '../../shared/components/app-hidden/AppHidden';
import { useAppContext } from '../../saas/AppConfigWrapper';
import {
  getStringFromLS,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import { APP_LOGO_URL } from '../../saas/AppStorageStaticNames';

function LoginPagefly24hrs() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(NAVIGATION_ROUTES.AGENT_REGISTRATION);
  };

  const handleDistributorClick = () => {
    window.location.href =
      'https://admin.fly24hrs.online/distributor/index.html';
  };

  const primaryS3Url = `https://iweenclientuploads.s3.ap-south-1.amazonaws.com/${appConfig?.appDbName}_index_1.jpeg`;
  const secondaryAdminUrl = `${appConfig?.appMainUrl}bannerimg/${appConfig?.appDbName}_indexindex1.jpg`;
  const [bgImage, setBgImage] = useState(primaryS3Url);
  const DEFAULT_IMAGE = '/images/others/nologinimg.png';

  useEffect(() => {
    const img = new Image();
    img.src = primaryS3Url;
    img.onload = () => setBgImage(primaryS3Url);
    img.onerror = () => {
      const defaultImg = new Image();
      defaultImg.src = secondaryAdminUrl;
      defaultImg.onload = () => setBgImage(secondaryAdminUrl);
      defaultImg.onerror = () => setBgImage(DEFAULT_IMAGE);
    };
  }, [primaryS3Url]);

  const getPortFolioLink = () => {
    try {
      const servicesLinks = getValueFromAppConfig('SAAS_APP_SERVICES_LINK')
        .split(',')
        .reduce((acc, cur) => {
          acc.push({
            service: cur.split('@@@')[0],
            link: cur.split('@@@')[1],
          });
          return acc;
        }, []);
      const portfolioService = servicesLinks.find(
        (x) => x.service === 'portfolio',
      );
      if (portfolioService) {
        return portfolioService.link;
      }
      return '';
    } catch (error) {
      return '';
    }
  };

  return (
    <>
      {/* ── HEADER ── */}
      <div className="login-page-fly24_header">
        <div className="login-page-fly24_header_container d-flex align-items-center justify-content-between">
          <div
            className="d-flex align-items-center gap-2"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            {getStringFromLS(APP_LOGO_URL) && (
              <img
                src={getStringFromLS(APP_LOGO_URL)}
                alt={appConfig.companyName}
                style={{ maxHeight: `${appConfig.logoHeight || 44}px` }}
              />
            )}
            {appConfig.showNameinLoginHeader && (
              <span className="fs-5 fw-600">{appConfig.companyName}</span>
            )}
          </div>
          <div className="d-flex align-items-center gap-3">
            {appConfig.helpline24 && (
              <div className="fs-14 fw-600 hide-in-mobile d-flex align-items-center gap-2">
                <span>📞 24×7 Helpline:</span>
                <a
                  href={`tel:${appConfig.supportNumber}`}
                  style={{
                    textDecoration: 'none',
                    color: 'var(--primaryColor, #0d6efd)',
                  }}
                >
                  {appConfig.supportNumber}
                </a>
              </div>
            )}
            {appConfig.hasPortfolio && (
              <AppLink
                variant="primary"
                isLink
                href={getPortFolioLink()}
                target="_blank"
                linkText="Portfolio"
              />
            )}
          </div>
        </div>
      </div>

      <div className="login-page-fly24 pt-sm-5 pt-2">
        {/* ── BANNER / LOGIN SECTION ── */}
        <div className="login-page-fly24_banner">
          <div className="login-page-fly24_banner_container row flex-md-row flex-column-reverse">
            <AppHidden xsDown>
              <div className="col-md-8">
                <div
                  className="app-landing-page__carousel_item"
                  style={{ backgroundImage: `url(${bgImage})` }}
                />
              </div>
            </AppHidden>

            <div className="col-md-4 login-section d-flex flex-column justify-content-center">
              <Login />

              {/* Separator + Register */}
              <div className="d-flex flex-column gap-2 login-container_registration w-100 mt-2">
                <div className="login-container_registration_seperator position-relative text-center">
                  <span className="fs-14 grey-color position-absolute">or</span>
                </div>
                <button
                  type="button"
                  className="fly24-register-btn"
                  onClick={handleClick}
                >
                  Register with us
                </button>
                <button
                  type="button"
                  className="fly24-register-btn fly24-distributor-btn"
                  onClick={handleDistributorClick}
                >
                  Distributor Login
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── BUSINESS SECTION ── */}
        <AppHidden xsDown>
          <div className="login-page-fly24_business pb-5">
            <div className="login-page-fly24_business_container pt-5">
              <div className="row mt-2">
                <div className="col-md-8">
                  <div className="p-sm-5 p-2">
                    <h3>One-Stop B2B Travel Solution</h3>
                    <p>
                      Everything your agency needs — flights, hotels, buses and
                      insurance — all in one powerful platform.
                    </p>
                    <div className="d-flex flex-wrap gap-3">
                      <div className="d-flex flex-column align-items-center gap-2">
                        <div className="banner-icon">
                          <MdOutlineFlight />
                        </div>
                        <span className="banner-title">Flight</span>
                      </div>
                      <div className="d-flex flex-column align-items-center gap-2">
                        <div className="banner-icon">
                          <LuBedDouble />
                        </div>
                        <span className="banner-title">Hotel</span>
                      </div>
                      <div className="d-flex flex-column align-items-center gap-2">
                        <div className="banner-icon">
                          <MdDirectionsBus />
                        </div>
                        <span className="banner-title">Bus</span>
                      </div>
                      <div className="d-flex flex-column align-items-center gap-2">
                        <div className="banner-icon">
                          <LuShieldCheck />
                        </div>
                        <span className="banner-title">Insurance</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 business-image">
                  <video autoPlay loop muted>
                    <source
                      src="/images/logos/login-banner.webm"
                      type="video/webm"
                    />
                  </video>
                </div>
              </div>
            </div>
          </div>

          {/* ── ADVANTAGES SECTION ── */}
          <div className="login-page-fly24_advantage pb-5 pt-3">
            <div className="login-page-fly24_advantage_container">
              <div className="fs-3 fw-600 text-center mb-4">
                {appConfig?.companyName} Advantages
              </div>
              <div className="row mb-3">
                <div className="col-sm-6 col-12">
                  <div className="advantage-row-item d-flex gap-3 align-items-center">
                    <div className="advantage-svg">
                      <LuCircleDollarSign />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-16 fw-600">Automated Payments</span>
                      <span className="fs-12">
                        Streamlined payment processing with automated
                        reconciliation for your agency.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="advantage-row-item d-flex gap-3 align-items-center">
                    <div className="advantage-svg">
                      <LuHotel />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-16 fw-600">50+ Hotel Suppliers</span>
                      <span className="fs-12">
                        Access a wide network of hotel suppliers for competitive
                        rates and inventory.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6 col-12">
                  <div className="advantage-row-item d-flex gap-3 align-items-center">
                    <div className="advantage-svg">
                      <LuGlobe2 />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-16 fw-600">
                        Largest Network of Airfares
                      </span>
                      <span className="fs-12">
                        Access to the widest selection of domestic and
                        international airfares.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="advantage-row-item d-flex gap-3 align-items-center">
                    <div className="advantage-svg">
                      <LuCable />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-16 fw-600">
                        API / XML Integration
                      </span>
                      <span className="fs-12">
                        Seamlessly integrate with your existing systems via our
                        robust API and XML feeds.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-6 col-12">
                  <div className="advantage-row-item d-flex gap-3 align-items-center">
                    <div className="advantage-svg">
                      <LuMonitorSmartphone />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-16 fw-600">Mobile Friendly</span>
                      <span className="fs-12">
                        Fully responsive platform that works seamlessly on all
                        devices and screen sizes.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="advantage-row-item d-flex gap-3 align-items-center">
                    <div className="advantage-svg">
                      <LuCog />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-16 fw-600">Post-Booking Service</span>
                      <span className="fs-12">
                        Complete post-booking support including amendments,
                        cancellations and refunds.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AppHidden>
      </div>

      {/* ── FOOTER ── */}
      <AppHidden xsOnly>
        <footer className="login-page-fly24_footer">
          <div className="login-page-fly24_footer_container py-sm-4 py-3">
            <div className="row">
              <div className="col-md-3 col-sm-4 col-5">
                <div className="d-flex flex-column gap-1">
                  <p>More Links</p>
                  <span onClick={() => navigate('/terms-conditions')}>
                    Terms &amp; Conditions
                  </span>
                  <span onClick={() => navigate('/privacy-policy')}>
                    Privacy Policy
                  </span>
                  <span onClick={() => navigate('/disclaimer')}>
                    Disclaimer
                  </span>
                  <span onClick={() => navigate('/refund-policy')}>
                    Refund Policy
                  </span>
                </div>
              </div>
              <div className="col-md-3 col-sm-4 col-4">
                <div className="d-flex flex-column gap-1">
                  <p>Company</p>
                  <span onClick={() => navigate('/')}>Home</span>
                  <span onClick={() => navigate('/about-us')}>About Us</span>
                  <span onClick={() => navigate('/contact-us')}>
                    Contact Us
                  </span>
                </div>
              </div>
              <div className="col-md-3 col-sm-4 col-3">
                <div className="d-flex flex-column gap-1">
                  <p>Products</p>
                  <span onClick={() => navigate('/')}>Flights</span>
                  <span onClick={() => navigate('/hotel')}>Hotels</span>
                  <span>Insurance</span>
                </div>
              </div>
              {appConfig.supportNumber && (
                <div className="col-md-3 col-sm-12">
                  <div className="d-flex flex-column gap-1">
                    <p>Get In Touch</p>
                    <a href={`tel:${appConfig.supportNumber}`}>
                      📞 {appConfig.supportNumber}
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </footer>
      </AppHidden>
    </>
  );
}

export default LoginPagefly24hrs;
